import jonify from '@utils/jonify';
import formatLocation from '@utils/format-location';
import formatAbsoluteUrl from './absolute-url';

export const formatSearchCanonicalUrl = (
  categoryName: string,
  location: string,
) => {
  const firstLocation = location?.split(',')[0].trim() || '';
  const formattedLocation = jonify(formatLocation(firstLocation));

  if (formattedLocation && categoryName) {
    return `/Search/${jonify(categoryName)}/in/${formattedLocation}`;
  }

  return '/Search';
};

export const formatSearchCanonicalUrlAbsolute = (
  categoryName: string,
  location: string,
) => {
  return formatAbsoluteUrl(formatSearchCanonicalUrl(categoryName, location));
};
